/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Cli_DescInputs */

const en_rd_cli_desc = /** @type {(inputs: Rd_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same scorer ships in the CLI, so private repos never leave your machine:`)
};

const id_rd_cli_desc = /** @type {(inputs: Rd_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilai yang sama ada di CLI, jadi repo privat tidak perlu keluar dari komputermu:`)
};

/**
* | output |
* | --- |
* | "The same scorer ships in the CLI, so private repos never leave your machine:" |
*
* @param {Rd_Cli_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_cli_desc = /** @type {((inputs?: Rd_Cli_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Cli_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_cli_desc(inputs)
	return en_rd_cli_desc(inputs)
});